import { Box, Button, Divider } from '@factorialco/deprecated-design-system'
import { FormikProps } from 'formik'
import { TaxTypeFragment } from 'generated/resources/graphql'
import { v4 as uuid } from 'uuid'

import { toCents } from 'modules/core/lib/formatCurrencyUtils'
import i18n from 'modules/core/lib/i18n'

import TaxFieldsSelector from 'modules/expenses/components/expenses/Form/TaxFieldsSelector'
import { Tax } from 'modules/expenses/hooks/useExpensesCustomization'

import { InvoiceForm } from '../types'

interface TaxesSectionProps {
  form: FormikProps<InvoiceForm>
  readonly: boolean
  countryCode?: string
  taxTypes?: TaxTypeFragment[]
}

export const TaxesSection: React.FC<TaxesSectionProps> = ({
  form,
  readonly,
  countryCode,
  taxTypes,
}) => {
  const onAddTax = () =>
    form.setValues({
      ...form.values,
      taxes: [...form.values.taxes, { id: uuid(), type: 'vat', tax_rates: [], tax_type_id: null }],
    })

  const onChangeTax = (tax: Tax) =>
    form.setValues({
      ...form.values,
      taxes: form.values.taxes.map((oldTax: Tax) => (tax.id === oldTax.id ? tax : oldTax)),
    })

  const onDeleteTax = (tax: Tax) =>
    form.setValues({
      ...form.values,
      taxes: form.values.taxes.filter((oldTax: Tax) => tax.id !== oldTax.id),
    })

  return (
    <>
      {form.values.taxes.length > 0 && (
        <>
          <Box gap="s16" gapDivider width="full">
            {form.values.taxes.map((tax: Tax) => (
              <TaxFieldsSelector
                countryCode={countryCode}
                showErrors={false}
                key={tax.id}
                tax={tax}
                readonly={readonly}
                amount={toCents(Number(form.values.totalAmountCents))}
                currency={form.values.currency || ''}
                autofilled={false}
                onChange={onChangeTax}
                onDelete={onDeleteTax}
                taxTypes={taxTypes}
              />
            ))}
          </Box>
          <Divider />
        </>
      )}

      {!readonly && (
        <Box alignItems="flexStart">
          <Button type="secondary" onClick={onAddTax} iconName="add">
            {i18n.t('expenses_v2.forms.fields.taxes.add')}
          </Button>
        </Box>
      )}
    </>
  )
}
